export default __webpack_public_path__ + "580d3305ec30999adabd3569d825e796.png";